import { createFileRoute } from "@tanstack/react-router";
import { SEO } from "@/features/marketing/seo";
import { ChecklistTool } from "@/features/marketing/tools/checklist-tool";

export const Route = createFileRoute("/_marketing/wedding-checklist")({
  head: SEO.checklist,
  component: ChecklistTool,
});
